import { SET_TEACHER_PROFILE, TEACHER_PROFILE_ERROR } from '../Actions/types';

const initialState = {
  profile: null,
  error: null,
};

const teacherProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TEACHER_PROFILE:
      return {
        ...state,
        profile: action.payload,
        error: null,
      };
    case TEACHER_PROFILE_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default teacherProfileReducer;
